import GeneralInformationSection from "./GeneralInformationSection";
export default GeneralInformationSection;
